<rt-button
  #quickFilterOrigin="rtOverlayOrigin"
  rt-overlay-origin
  [dropdownOpened]="quickFilter.open"
  [dropdownVisible]="filterControl.invalid"
  [rtTooltip]="filterTooltip"
  [rtTooltipEnabled]="filterControl.valid"
  [active]="filterControl.valid"
  size="small"
  variant="tertiary"
  (click)="quickFilter.open = true"
>
  <rt-truncate class="label" ngPreserveWhitespaces>
    <span text-weight-semi-bold>{{ filterLabel.name }}</span>
    <span text-bold>{{ filterLabel.value }}</span>
  </rt-truncate>
  @if (filterControl.valid) {
    <rt-icon (click)="onClear($event)" name="close" />
  }
</rt-button>

<ng-template #conditionTooltipTmpl>
  <span>{{ 'app.views.filters.condition_tooltip' | translate }}</span>
  <ul class="condition-tooltip">
    @for (condition of filterDef.conditions; track trackById($index, condition)) {
      <li>
        <strong>{{ condition.label }}</strong> -
        <span>{{ condition.description }}</span>
      </li>
    }
  </ul>
</ng-template>

<ng-template
  #quickFilter="rtConnectedOverlay"
  rt-connected-overlay
  [origin]="quickFilterOrigin"
  [hasBackdrop]="true"
  [minWidth]="300"
  [rtConnectedOverlayPosition]="OverlayPosition.BottomLeft"
  [rtConnectedOverlayAutoClose]="false"
  (backdropClick)="quickFilter.open = false"
>
  <rt-dropdown [width]="DropdownWidth.FullWidth">
    <rt-dropdown-header [fullWidthTitle]="true">
      <ng-container ngProjectAs="rt-segmented-control">
        <div layout layout-full-width layout-align-items-center>
          @if ((showBackButton$ | ngrxPush) ?? false) {
            <rt-icon-button
              size="small"
              variant="plain"
              iconName="arrow-back"
              margin-right-small-x
              (click)="showBackButton$.next(false)"
            />
          }
          <rt-heading>{{ filterDef.name }}</rt-heading>
          @if (!isNoInputFilter) {
            <rt-select2
              [formControl]="filterControl.controls.condition"
              [items]="conditionOptions"
              [overlayWidth]="122"
              margin-left-auto
            >
              <rt-select-trigger-button
                *rtSelectTrigger
                [buttonVariant]="'plain'"
                rtTooltip
                [rtTooltipTemplate]="conditionTooltipTmpl"
                [rtTooltipPosition]="'righttop'"
                [rtTooltipShowDelay]="1000"
              />
            </rt-select2>
          }
        </div>
      </ng-container>
    </rt-dropdown-header>
    <div class="quick-controls" [class.no-padding]="isOnlySelect || isNoInputFilter">
      <ng-container #inputsRef />
      @if (isNoInputFilter) {
        <rt-select2
          [formControl]="filterControl.controls.condition"
          [items]="conditionOptions"
          alwaysOpen
        >
          <ng-template rtSelectTrigger />
        </rt-select2>
      }
      @if (!filterInputDefs.length && !isNoInputFilter) {
        {{ conditionIdMap[filterControl.value.condition!].description }}
      }
    </div>
  </rt-dropdown>
</ng-template>
